import { render, staticRenderFns } from "./BaselineCategoryDataGrid.vue?vue&type=template&id=370aefaa&scoped=true"
import script from "./BaselineCategoryDataGrid.vue?vue&type=script&lang=js"
export * from "./BaselineCategoryDataGrid.vue?vue&type=script&lang=js"
import style0 from "./BaselineCategoryDataGrid.vue?vue&type=style&index=0&id=370aefaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370aefaa",
  null
  
)

export default component.exports